import { JSX } from "react";

const AttestationBasedAlertsDescription = (): JSX.Element => {
  return <>
    <p>
      Attestation-based alerts highlight issues confirmed through the BetterDoctor® outreach and attestation process, where provider offices confirm the status of each service location and the associated practitioners.
      Alerts from this category offer additional insight into the integrity of the network but are limited to the locations actively contacted during the current outreach workflow and may not be available for the full network.
    </p>
    <p>
      Attestation-based Alerts:
    </p>
    <ul>
      <li>
        <b>Closed Location</b>: Indicates an attestation has marked the entire location as being closed and no longer seeing patients
      </li>
      <li>
        <b>Retired Practitioner</b>: Indicates an attestation has marked the practitioner as fully retired and no longer seeing patients at any location
      </li>
      <li>
        <b>Left Office</b>: Indicates an attestation has marked the practitioner as having left the office
      </li>
      <li>
        <b>Not Recognized</b>: Indicates an attestation has marked the practitioner as not being recognized by name or NPI by the attester
      </li>
      <li>
        <b>No Longer On Roster</b>: Indicates a roster change identified by comparing large group and health system rosters over time
      </li>
      <li>
        <b>Termed On Roster</b>: Indicates a roster change identified on the roster itself
      </li>
    </ul>
    <p>
      Attestation-based alerts offer an added layer of confirmation about network integrity, helping to validate what&apos;s reflected in the network data.
    </p>
    <p>
      Detailed network provider information is available when combined with an active QES® Accuracy license.
    </p>
  </>;
}

export { AttestationBasedAlertsDescription };